import React, {Component} from 'react';
import {Form, Input, Button, Space, List, Typography, Divider, notification } from 'antd';
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {t} from '../../../constant/i18n';



class AccompagnateurBloc extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataAcomp: false,
            accompAdd: false,
        }
    }



    componentDidMount = async () => {
        if (localStorage.getItem('order_accompagnateurs')) {
            const liste = await JSON.parse(localStorage.getItem('order_accompagnateurs'))
            const dataAcc = await this.acompCmd(liste)
            await this.setState({dataAcomp: dataAcc})
        }
    }

    delAccomp =(e,key)=> {

        const liste = JSON.parse(localStorage.getItem('order_accompagnateurs'))
        liste.accompagnateur.splice(key,1)
        var newAcc = liste.accompagnateur


        if (Array.isArray(newAcc) && newAcc.length){
            const dataAcc = this.acompCmd(liste);
            this.setState({dataAcomp: dataAcc});
            localStorage.setItem('order_accompagnateurs',JSON.stringify(liste));
        }else{
            localStorage.removeItem('order_accompagnateurs');
            this.setState({dataAcomp: false});
        }

        //const dataAcc = this.acompCmd(liste)
       // this.setState({dataAcomp: dataAcc})
       // localStorage.setItem('order_accompagnateurs',JSON.stringify(liste))
    }

    acompCmd = (dataAcc) => {

        if (typeof dataAcc != 'undefined') {

            const dataFinal = []
            for (const [key, value] of Object.entries(dataAcc.accompagnateur)) {
                dataFinal.push({
                    key : key,
                    first : value.first,
                    last : value.last,
                    email : value.email,
                })
            }

            return (
                <div>
                    <List
                        header={<div>{t('accompagnateur.yourCompanions')}</div>}
                        bordered
                        dataSource={dataFinal}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    title={item.first +' '+item.last+' '+item.email}
                                />
                                <div>
                                    <Button data-id={item.key} onClick={(e,id)=>this.delAccomp(e,item.key)} type="primary" danger>
                                    {t('accompagnateur.erase')}
                                </Button>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
            )
        } else {
            return false
        }
    }


    render() {

        const onFinish = values => {
            var accomp = JSON.stringify(values);
            console.log(accomp)
            localStorage.setItem("order_accompagnateurs", accomp);
            notification['success']({
                message: t('accompagnateur.updated'),
                description: t('accompagnateur.updatedDesc'),
            });
        };

        if (this.state.dataAcomp) {
            var listeAcc = this.state.dataAcomp
        } else {
            var listeAcc = ''
        }

        return (
            <div>
                {
                    (this.state.dataAcomp)?listeAcc: ""
                }

                <Divider orientation="left">{t('accompagnateur.addNewPerson')}</Divider>
                <Form name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off">
                    <Form.List name="accompagnateur">
                        {(fields, {add, remove}) => {
                            return (
                                <div>
                                    {fields.map(field => (
                                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}} align="start">
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'first']}
                                                fieldKey={[field.fieldKey, 'first']}
                                                rules={[{required: true, message: t('accompagnateur.missingFirstName')}]}
                                            >
                                                <Input placeholder={t('orderTransactions.firstName')}/>
                                            </Form.Item>

                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'last']}
                                                fieldKey={[field.fieldKey, 'last']}
                                                rules={[{required: true, message: t('accompagnateur.missingLastName')}]}
                                            >
                                                <Input placeholder={t('orderTransactions.lastName')}/>
                                            </Form.Item>

                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'email']}
                                                fieldKey={[field.fieldKey, 'email']}
                                                rules={[{required: true, message: t('accompagnateur.missingEmail')}]}
                                            >
                                                <Input placeholder={t('common.email')}/>
                                            </Form.Item>

                                            <MinusCircleOutlined
                                                onClick={() => {
                                                    remove(field.name);
                                                }}
                                            />
                                        </Space>
                                    ))}


                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => {
                                                add();
                                                this.setState({accompAdd:true})
                                            }}
                                            block
                                        >
                                            <PlusOutlined/> {t('accompagnateur.addPerson')}
                                        </Button>
                                    </Form.Item>
                                </div>
                            );
                        }}
                    </Form.List>

                    <Form.Item>
                        {
                            (this.state.accompAdd)?<Button type="primary" htmlType="submit">
                                {t('accompagnateur.validateCompanions')}
                            </Button>: ""
                        }

                    </Form.Item>
                </Form>
            </div>
        );
    }
}

export default AccompagnateurBloc;